export const home = {
  soon: "Em breve",
  soonLaunch: "Araria está em beta.",
  hero: {
    title: "Todos os Modelos Premium de IA em um só lugar",
    subtitle:
      "Por que pagar várias assinaturas? Tenha acesso ao GPT-4, Claude, Gemini, Geração de Imagens e Vídeos e mais em uma única plataforma.",
    cta: "Preços",
    titleBottom: "Comece grátis agora mesmo!",
    titleBottomDescription:
      "Plano Free não requer cartão de crédito, os modelos gratuitos são:",
  },
  providers: {
    title: "Acesse os Principais Provedores de IA",
    subtitle: "Uma plataforma, múltiplos modelos de IA de ponta ao seu alcance",
    openai: "OpenAI",
    anthropic: "Anthropic",
    google: "Google",
    mistral: "Mistral AI",
    deepseek: "DeepSeek",
    meta: "Meta AI",
    groq: "Groq",
    maritaca: "Maritaca AI",
    alibaba: "Alibaba",
    midjourney: "MidJourney",
    perplexity: "Perplexity",
    flux: "Flux",
    stabilityai: "Stability AI",
    ollama: "Ollama",
    runway: "Runway",
    runware: "Runware",
    playht: "PlayHT",
    decor8: "Decor8",
    civitai: "CivitAI",
    mxbai: "Mixedbread AI",
    cohere: "Cohere AI",
    suno: "Suno",
    kling: "Kling AI",
    viewModels: "Ver Modelos",
    whatsapp: "WhatsApp",
    twilio: "Twilio",
    contentful: "Contentful",
  },
  thirdParty: {
    title: "Integrações Third Party",
    subtitle: "Conheça algumas de nossas integrações oficiais",
  },
  typeAnimationFeatures: [
    {
      title:
        "Não gostou da resposta do ChatGPT/Claude/Gemini? Teste sua conversa com vários modelos usando reprompt rápido!",
    },
    {
      title: "Tá querendo criar videos? Use Kling AI, Runway e Hailuo e Luma!",
    },
    {
      title:
        "Geração de imagens top de linha? 🦄 Use CivitAI, Flux e MidJourney com preços super competitivos!",
    },
    {
      title:
        "Tá precisando de uma trilha sonora ou música pro seu projeto? 🎶 Use Suno e Udio!",
    },
    {
      title:
        "Que tal criar personas com IA e bater aquele papo com Gandhi no estilo Character.AI?",
    },
    {
      title:
        "Seu chatbot é fraco? Experimente usar nossos Agentes com ferramenta de scraping e base de conhecimento 🔥",
    },
    {
      title:
        "🦸 Dê Super Poderes a seus Agentes com ferramentas para seu agente lidar com desafios diversos!",
    },
    {
      title:
        "É tanta coisa que dá pra fazer por aqui, use as Pastas para organizar seus chats e gerações 😜",
    },
    {
      title:
        "Precisa descobrir qual modelo de IA é melhor para o seu desafio? Compare resultados lado a lado!",
    },
    {
      title:
        "Precisando de um chatbot para seu site ou loja? Use o Embed de Agentes pra plugar rapidinho!",
    },
    {
      title:
        "Comece usar a Araria a partir de R$ 36,00 de depósito, sem assinatura, sem compromisso, não expira.",
    },
    {
      title:
        "Tá precisando de uma solução customizada pro seu negócio? Integramos com qualquer sistema, CRM, ERP, APIs, etc.",
    },
    {
      title:
        "Seu sistema ou site precisa de inteligência? 🔮 Use nossa API, disponibilizamos endpoints para você conectar com o Araria.",
    },
    {
      title:
        "Além da nossa API, sabia que também temos SDK? Confira nossos SDKs pra NodeJS e Python no GitHub!",
    },
  ],
  features: {
    title: "Potencialize seu fluxo de trabalho com IA",
    subtitle:
      "Desbloqueie todo o potencial da IA com nosso conjunto abrangente de recursos",
    reprompting: {
      title: "Reprompt Rápido",
      description:
        "Envie rapidamente seu prompt para outro modelo para obter um resultado diferente e beneficie-se da diversidade de possíveis respostas.",
    },
    upload: {
      title: "Upload de Imagens e Documentos",
      description:
        "Faça upload e analise imagens ou documentos facilmente, permitindo que a IA processe informações visuais e extraia insights.",
    },
    devices: {
      title: "Múltiplos dispositivos",
      description:
        "Acesse o aplicativo de qualquer dispositivo: Android, iPhone e Desktop. Acesso rápido pela barra de tarefas ou telefone.",
    },
    history: {
      title: "Histórico de Chat",
      description:
        "Acesse e revise conversas anteriores, permitindo continuidade nas discussões e fácil referência a informações anteriores.",
    },
    multilingual: {
      title: "Modelos Multilíngues",
      description:
        "Comunique-se e gere conteúdo em vários idiomas, quebrando barreiras linguísticas e expandindo a usabilidade global.",
    },
    folders: {
      title: "Pastas",
      description:
        "Organize seus chats e gerações em pastas para facilitar a navegação e a busca por conversas específicas.",
    },
    sideBySide: {
      title: "Conversação Lateral",
      description:
        "Converse com vários modelos de IA ao mesmo tempo, para comparar resultados e escolher o melhor modelo para sua tarefa.",
    },
    memory: {
      title: "Memória",
      description:
        "Controle quanta memória é usada como contexto para otimizar suas necessidades, balanceando entre desempenho e custo.",
    },
    slides: {
      title: "Slides",
      description:
        "Gere apresentações de slides com IA, permitindo que você crie conteúdo visual para seus projetos ou uso pessoal/comercial.",
    },
    image: {
      title: "Geração de Imagens",
      description:
        "Gere imagens usando mais de 200 mil modelos da CivitAI e Flux, controles avançados e manipulação de imagens.",
    },
    api: {
      title: "API",
      description:
        "Integre facilmente a Araria nos processos e sistemas da sua empresa, com uma API diversa e preços justos.",
    },
    agents: {
      title: "Agentes de IA",
      description:
        "Crie e gerencie agentes de IA para diferentes contextos e tarefas complexas, integrações e ferramentas para automatização.",
    },
    video: {
      title: "Geração de Vídeos",
      description:
        "Gere vídeos com uma diversidade de provedores para você criar conteúdo visual para seus projetos ou uso pessoal/comercial.",
    },
    characters: {
      title: "Personagens",
      description:
        "Crie personagens/especialistas com IA, permitindo interações especializadas com seu toque, tom e base de conhecimento.",
    },
    users: {
      title: "Usuários",
      description:
        "Gerencie sub-usuários que podem utilizar seus agentes proprietários, crie acessos exclusivos para seus agentes especialistas.",
    },
    tools: {
      title: "Ferramentas",
      description:
        "Dê super poderes a seus agentes com ferramentas diversas, como integrações com SERP, Geocoding, Web Search, Scraping e mais.",
    },
  },
  futureFeatures: {
    title: "Em desenvolvimento",
    subtitle:
      "Estamos trabalhando constantemente para melhorar o Araria e fornecer a melhor experiência em IA pra você!",
    imageGeneration: {
      title: "Geração de Imagens",
      description:
        "Gere imagens usando modelos de IA, permitindo que você crie conteúdo visual para seus projetos ou uso pessoal/comercial.",
    },
    videoGeneration: {
      title: "Geração de Vídeos",
      description:
        "Gere vídeos com uma diversidade de provedores para você criar conteúdo visual para seus projetos ou uso pessoal/comercial.",
    },
    assistant: {
      title: "Assistente de Projeto",
      description:
        "Configure seu assistente de IA ideal fornecendo um contexto, para que ele possa ajudá-lo melhor em seu projeto ou tarefa diária.",
    },
    agents: {
      title: "Agentes de IA",
      description:
        "Crie e gerencie agentes de IA para diferentes contextos e tarefas complexas, integrações com serviços terceiros e ferramentas para automatizar seu fluxo de trabalho.",
    },
    enterpriseAPI: {
      title: "API Empresarial",
      description:
        "Acesse nossa API para chamadas em volume, reduzindo a complexidade de integração com múltiplos provedores e ferramentas de IA.",
    },
    training: {
      title: "Treinamento de Modelos",
      description:
        "Treine modelos de IA personalizados para atender às suas necessidades específicas.",
    },
    speech: {
      title: "Conversação com IA",
      description:
        "Converse com IA usando voz e texto, permitindo que você interaja com a IA de maneira natural.",
    },
  },
  gallery: {
    title: "Geração de Imagens",
    subtitle: "Escolha entre uma diversidade de modelos de geração de imagem!",
  },
  video: {
    title: "Geração de Vídeos",
    subtitle: "Gere novos vídeos com texto, imagens ou videoclipes",
    feature1: {
      title: "Prompt template",
      description:
        "Escolha templates de prompts apropriados para geração de vídeos",
    },
    feature2: {
      title: "Primeira e última",
      description: "Escolha a partir de onde gerar seu vídeo",
    },
    feature3: {
      title: "Duração de Vídeos",
      description: "Escolha a duração do vídeo que você quer gerar (5-10s)",
    },
  },
  agentChat: {
    title: "Tá em dúvida?",
    subtitle: "Pergunta nossa assistente de IA, ela sabe tudo!",
    button: "Chat",
  },
  faq: {
    title: "Tá em dúvida?",
    subtitle: "Perguntas Frequentes",
    questions: {
      models: {
        question: "Quais são os modelos de IA disponíveis atualmente?",
        answer:
          "As versões atuais dos modelos disponíveis no Araria incluem GPT-4, Claude 3.5 Sonnet, Gemini 2.0 Flash, Llama 3.3 70B, e Mistral Large 2. Atualizamos continuamente nossa seleção de modelos para proporcionar a melhor experiência em IA.",
      },
      selection: {
        question: "Como vocês selecionam os modelos de IA?",
        answer:
          "Selecionamos cuidadosamente os melhores modelos de IA com base em benchmarks de desempenho, incluindo comparadores abertos de LLM como lmsys.org e estudos universitários como Berkeley Function Calling Leaderboard e livebench.ai.",
      },
      assistants: {
        question: "O que são os Assistentes de Projeto?",
        answer:
          "Um Assistente de Projeto é uma IA personalizada que você fornece com conhecimento específico. Assim, ele pode responder suas perguntas diárias sem a necessidade de repetir o contexto. Você pode comparar o desempenho dos seus assistentes em diferentes modelos com um clique.",
      },
      availability: {
        question: "Posso acessar todos os modelos de qualquer lugar?",
        answer:
          "Fornecemos acesso a modelos premium de IA usando APIs oficiais. Alguns modelos podem ter restrições regionais baseadas nas políticas dos provedores. O Araria funciona em servidores de borda mais próximos da sua localização para um desempenho ideal.",
      },
      tokenCount: {
        question: "Quantos caracteres tem um token?",
        answer:
          "A quantidade de caracteres em um token varia de acordo com o modelo e o idioma, mas geralmente um token é equivalente a uma palavra (ou 4-7 caracteres por token).",
      },
    },
  },
};
